import React from "react";
import Table from "../../../../../components/Table";
import { usersPageLoad } from "../../../actions/users";
import {
  usersAdmin,
  usersTech,
  usersLoadInProgress,
} from "../../../selectors/users";
import { connect } from "react-redux";
import PageTitle from "../../../components/PageTitle";
import { push } from "react-router-redux";
import { Button, Glyphicon, Panel } from "react-bootstrap";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import DisableBadge from "sc/ui/sites/oncall/components/DisableBadge";

export default connect(
  (state, ownProps) => ({
    partnerUsersAdmin: usersAdmin(state),
    partnerUsersTech: usersTech(state),
    loading: usersLoadInProgress(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(usersPageLoad()),
    onAddUser: () => dispatch(push("users/new")),
    onEditUser: username => dispatch(push(`/user/edit/${username}`)),
  }),
)(
  componentWithLoadTrigger(props => {
    const actions = [
      {
        id: "edit-user",
        text: " Edit",
        className: "btn-primary",
        glyph: "glyphicon glyphicon-pencil",
        onClick: props.onEditUser,
      },
    ];

    const columns = [
      {
        header: "",
        data: user => user.username,
        badges: user => {
          const allBadges = [];
          if (!user.enabled)
            allBadges.push([<DisableBadge key="disabled-badge" />]);
          return allBadges;
        },
      },
    ];

    return (
      <div id="security-coverage-users-page">
        <PageTitle title="Users" />
        <Button id="add-user" onClick={props.onAddUser} className="btn-success">
          <Glyphicon glyph="glyphicon glyphicon-plus" />
          &nbsp;Add User
        </Button>
        <Panel bsStyle="info" id="users-admin-panel">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Administrators</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Table
              data={props.partnerUsersAdmin}
              columns={columns}
              actions={actions}
              identityProperty="username"
              noDataMessage="No users of type admin defined"
              loading={props.loading}
              loadingMessage="Loading..."
            />
          </Panel.Body>
        </Panel>

        <Panel bsStyle="info" id="users-tech-panel">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Technicians</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Table
              data={props.partnerUsersTech}
              columns={columns}
              actions={actions}
              identityProperty="username"
              noDataMessage="No users of type tech defined"
              loading={props.loading}
              loadingMessage="Loading..."
            />
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/admin/users/List.js